export const environment = {
  production: true,
  buildNumber: '1.0.138',
  internalExamUrl: 'https://egzamin-wewnetrzny.testy-na-prawko.net',
  //internalExamUrl: 'http://localhost:4200',
  webApiUrl: 'https://api.testy-na-prawko.net',
  //webApiUrl: 'https://api.testy-na-prawko.net',
  //webApiUrl: 'https://api.testy-na-prawko.net',
  //webApiUrl: 'https://api.testy-na-prawko.net',

  googleApiUrl: 'https://api.testy-na-prawko.net',
  googleClientId:
    '607351128929-nivd26se6uj5935lej3jsgaoffakq78q.apps.googleusercontent.com',
  facebookId: '346224731646781',
  appleClientId: 'com.testynaprawko.webapplelogin',
  appleRedirectURI: 'https://testy-na-prawko.net/app/sign-in',
  // Microsoft Clarity project id; empty = no session recording.
  clarityProjectId: '',
};
